import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "bell",
  "use": "bell-usage",
  "viewBox": "0 0 65.99 66",
  "content": "<symbol viewBox=\"0 0 65.99 66\" id=\"bell\"><title>资源 86</title><g id=\"bell_图层_2\" data-name=\"图层 2\"><g id=\"bell_图层_1-2\" data-name=\"图层 1\"><path d=\"M65,51.26l-8.68-9.77V30.1a25.39,25.39,0,0,0-1.84-9.54,24.76,24.76,0,0,0-5-7.83A23.56,23.56,0,0,0,42,7.42a22.51,22.51,0,0,0-7-1.86V2A2,2,0,0,0,31,2V5.52a22.46,22.46,0,0,0-7.44,1.89,23.46,23.46,0,0,0-7.48,5.31,24.82,24.82,0,0,0-5,7.83,25.38,25.38,0,0,0-1.84,9.54V42L1,51.26A3.89,3.89,0,0,0,3.9,57.74H20.16a14.1,14.1,0,0,0,25.67,0H62.09A3.9,3.9,0,0,0,65,51.26ZM41.36,57.73a10.2,10.2,0,0,1-16.72,0Zm11.55-14.2,9.17,10.29h0l-58.17,0L12.66,44a2,2,0,0,0,.49-1.29V30.1C13.15,18.66,22,9.35,32.79,9.35S52.42,18.66,52.42,30.1V42.23A2,2,0,0,0,52.91,43.53Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/bell.svg
// module id = FvmK
// module chunks = 264